








































import {Component, Vue} from 'vue-property-decorator';

@Component({
  name: 'catalog-product-compare'
})

export default class extends Vue {
  private isOpen: boolean = false;

  private get productsToCompare(): Array<object> {
    return this.$store.state.CatalogCategoryCompare.productsToCompare;
  }

  private removeProduct(sku): void {
    this.$store.dispatch('CatalogCategoryCompare/setProductsToCompare', {
      product: {
        sku: sku
      },
      isCompare: false
    });

    if (this.productsToCompare.length < 1) {
      this.toggleCompare();
    }
  }

  private toggleCompare(): void {
    if (this.isOpen) {
      this.isOpen = false;
      document.body.classList.remove('no-scroll');
    } else {
      this.isOpen = true;
      document.body.classList.add('no-scroll');
    }
  }

  private get compareUrl(): string {
    const getSkus = this.productsToCompare.map(p => p['sku']);
    return `compare?sku[]=${getSkus.join('&sku[]=')}`;
  }

  private mounted(): void {
    const overlayEl = this.$refs.compareOverlay as HTMLElement;
    overlayEl.addEventListener('click', () => {
      this.isOpen = false;
      document.body.classList.remove('no-scroll');
    }, {passive: true});
  }
}
